import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Text, Flex, Box } from '@chakra-ui/react';
import { appContextSelector, isCorporateThemeSelector } from 'modules/app/appSlice';
import { currencies } from 'pages/shared/CorporateOffset/helpers/constants';
import { getPartnerSettings } from 'utils/partnerSettings';

const CurrencyInfo: FC = () => {
  const { t } = useTranslation('paymentMethod');
  const currentAccount = useSelector((state: RootState) => state.user.currentAccount);
  const context = useSelector(appContextSelector);
  const isCorporateTheme = useSelector(isCorporateThemeSelector);
  const currency = context === 'connect' ? currentAccount?.partnership?.currency : currentAccount?.customer?.payment?.currency;

  const availableCurrencies: string[] = isCorporateTheme
    ? currencies.filter(currency => {
        const settings = getPartnerSettings();
        if (settings?.currencies?.length) {
          return settings.currencies.includes(currency);
        }

        return true;
      })
    : currencies;

  const isSingleCurrencyOption = availableCurrencies.length && availableCurrencies.length === 1;

  return (
    <>
      <Text fontWeight={500} textStyle="p">
        {t('currency')}
      </Text>
      <Flex p="10px" bgColor={'secondary.200'} mt="5px" justifyContent="space-between" align="center">
        <Box>
          <Text color="secondary.500" textStyle="pXS" mb="5px">
            {t('yourCurrency')}
          </Text>
          <Text color="secondary.700" textStyle="p" mb="10px">
            {currency}
          </Text>
        </Box>
        {isCorporateTheme && !isSingleCurrencyOption && (
          <Text ml="5px" maxW={{ base: 'min(60%, 175px)', md: '153px' }} textStyle="pXS" color="secondary.600" textAlign="right">
            {t('currencyAdditionalInfo')}
          </Text>
        )}
      </Flex>
    </>
  );
};

export default CurrencyInfo;
